module.exports = __webpack_public_path__ + "img/ipad-mobile_jp.9ac491f.jpg";